<template>
  <div class="service-tip-tag-web" v-if="policyList.length">
    <div class="popup-content">
      <div class="popup-head" v-if="!hiddenTabs">
        <div class="popup-tabs">
          <div
            v-for="(tab, index) in tabs"
            :key="index"
            class="popup-tab-item"
            :class="{ 'popup-tab-item-active': activeTab === index || tabs.length === 1 }"
            @click="onTabChange(index)"
          >
            {{ tab }}
          </div>
        </div>
      </div>
      <div class="popup-body" :style="hiddenTabs ? 'margin-top:16px;' : ''" ref="scroll-container">
        <div
          v-for="(tabName, index) in tabs"
          :key="`tab${index}`"
          class="popup-section"
          :ref="`tab${index}-ref`"
        >
          <template v-if="index === 0 && policyList.length">
            <div class="popup-section-title">{{ tabName }}</div>
            <refund-policy
              :refund-policy="item"
              scene="TAG"
              v-for="(item, index) in policyList"
              :last-child="policyList.length - 1 === index"
              :key="index"
            />
          </template>
          <template v-if="index === 1">
            <div class="popup-section-title">{{ tabName }}</div>
            <tip-info :activity="activity" v-if="activity.id"></tip-info>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import fetch from "fetch";
import Activity from "../activity/model/activity";
import TipInfo from "../activity/detail/common/TipInfo";
import RefundPolicy from "../activity/detail/RefundPolicy";

export default {
  name: "ServiceTipTagWeb",

  components: {
    TipInfo,
    RefundPolicy,
  },
  props: {
    scene: {
      type: String, // ACTIVITY_DETAIL
      required: true,
    },
    activityId: {
      type: String,
      default: "",
    },
    ticketGoodId: {
      type: String,
    },
    ticketCount: {
      type: String,
    },
    orderId: {
      type: String,
    },
    initTab: {
      type: Number,
      default: 0,
    },
    initAnchorRefName: {
      type: String,
      default: "",
    },
    hiddenTabs: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      activeTab: this.initTab,
      scrollFix: -60,
      policyList: [],
      activity: {},
      isTabClicking: false,
      tabClickTimeout: null,
      scrollEndTimer: null,
      ticking: false,
    };
  },
  watch: {
    initTab() {
      if (this.activityId) {
        this.activeTab = newVal;
        this.$nextTick(() => {
          this.onTabChange(newVal);
        });
      }
    },
    initAnchorRefName(val) {
      if (this.activityId) {
        this.$nextTick(() => {
          this.onTabChange(this.activeTab, val);
        });
      }
    },
  },
  beforeMount() {
    if (this.activityId) {
      new Promise(async (resolve) => {
        const res = await this.getActivity();
        if (res.activity) {
          resolve(res);
        }
      })
        .then(async (res) => {
          await this.getTips();
          this.$nextTick(() => {
            if (this.initTab !== 0 || this.initAnchorRefName) {
              setTimeout(() => {
                console.log(this.policyList.slice(), 8888888889);
                this.onTabChange(this.initTab, this.initAnchorRefName);
              }, 1000);
            }
            const allowedOrigins = [
              "https://wwwbeta.piaoniu.com",
              "https://www.piaoniu.com",
              "http://lc.piaoniu.com",
            ];
            const height =
              this.$refs["scroll-container"] && this.$refs["scroll-container"].scrollHeight;
            // 把高度发送给父页面
            allowedOrigins.forEach((origin) => {
              window.parent.postMessage(
                { type: "iframeHeight", height: height + 80 },
                origin, // 生产环境建议改成你的主页面域名，更安全
              );
            });
            this.addScrollListeners();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      this.getTips();
    }
  },
  computed: {
    tabs() {
      if (this.activityId) {
        return ["服务说明", "购票须知"];
      } else {
        return ["服务说明"];
      }
    },
  },
  mounted() {},
  beforeDestroy() {
    if (this.activityId) {
      this.removeScrollListeners();
    }
  },
  methods: {
    getTips() {
      const params = {
        scene: this.scene,
      };
      if (this.activity.id) {
        params.activityId = this.activityId;
      }
      if (this.scene === "ORDER_CONFIRM") {
        params.ticketGroups = [
          {
            ticketGroupId: this.ticketGoodId,
            count: this.ticketCount,
          },
        ];
      }
      if (this.scene === "ORDER_DETAIL" && this.orderId) {
        params.orderId = this.orderId;
      }
      return new Promise(async (resolve, reject) => {
        fetch({
          url: "/v3/unified/tips",
          method: "POST",
          data: params,
        })
          .then((data) => {
            if (!data) {
              reject();
              return;
            }
            this.policyList = data.map((item) => {
              const { type, content, displayType, bizData, desc } = item;

              const refundRuleList = (bizData && bizData.refundRuleList) || [];
              const noTicketCompensateStandardVOList =
                (bizData && bizData.noTicketCompensateStandardVOList) || [];
              return {
                type,
                title: content,
                canRefund: displayType === "CORRECT",
                refundRuleList,
                noTicketCompensateStandardVOList,
                content:
                  type === "CAN_REFUND"
                    ? bizData && bizData.refundContent
                    : bizData && bizData.noTicketCompensateContent,
                tips:
                  type === "CAN_REFUND"
                    ? bizData && bizData.refundPolicyTips
                    : (bizData && bizData.noTicketCompensateTips) || desc,
              };
            });

            console.log(899999999);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async getActivity() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await fetch({
            url: "/v6/activityPageDetail",
            data: {
              activityId: this.activityId,
              supportSpeedPackBuy: true,
            },
          });

          if (res) {
            this.activity = new Activity(res.activity);
            resolve(res);
          } else {
            reject({});
          }
        } catch (error) {
          console.error("获取活动信息失败:", error);
          reject({});
        }
      });
    },
    addScrollListeners() {
      if (this.$refs["scroll-container"]) {
        this.$refs["scroll-container"].addEventListener("scroll", this.handleScroll);
        // this.$refs["scroll-container"].addEventListener("wheel", this.handleScroll);
        // this.$refs["scroll-container"].addEventListener("touchmove", this.handleScroll);
        // this.$refs["scroll-container"].addEventListener("keydown", this.handleScroll);
      }
    },
    removeScrollListeners() {
      if (this.$refs["scroll-container"]) {
        this.$refs["scroll-container"].addEventListener("scroll", this.handleScroll);
        // this.$refs["scroll-container"].removeEventListener("wheel", this.handleScroll);
        // this.$refs["scroll-container"].removeEventListener("touchmove", this.handleScroll);
        // this.$refs["scroll-container"].removeEventListener("keydown", this.handleScroll);
      }
    },
    handleScroll() {
      if (this.scrollEndTimer) clearTimeout(this.scrollEndTimer);
      if (this.isTabClicking) {
        // 如果是由点击引起的滚动，在最后一次滚动事件后 100ms 再解除锁定，防止提前触发 activeTab 抖动
        this.scrollEndTimer = setTimeout(() => {
          this.isTabClicking = false;
        }, 100);
        return;
      }

      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          const container = this.$refs["scroll-container"];
          if (!container) {
            this.ticking = false;
            return;
          }
          let activeIndex = 0;
          const containerRect = container.getBoundingClientRect();

          for (let i = this.tabs.length - 1; i >= 0; i--) {
            const ref = this.$refs[`tab${i}-ref`];
            const section = ref && ref[0];
            if (section) {
              const el = section.$el || section;
              if (el && el.getBoundingClientRect) {
                const sectionRect = el.getBoundingClientRect();
                // 运用 getBoundingClientRect 判断是否滚动出容器顶部，使用 10px 容错
                if (sectionRect.top <= containerRect.top + 10) {
                  activeIndex = i;
                  break;
                }
              }
            }
          }
          if (this.activeTab !== activeIndex) {
            this.activeTab = activeIndex;
          }
          this.ticking = false;
        });
        this.ticking = true;
      }
    },
    // 递归查找所有子组件和slot中的ref
    findRefByName(refName, component) {
      // 从当前组件开始查找
      if (component.$refs[refName]) {
        console.log(`Found ref ${refName} in component:`, component.$options.name || "anonymous");
        return component.$refs[refName];
      }

      // 递归查找子组件
      for (const child of component.$children) {
        const result = this.findRefByName(refName, child);
        if (result) {
          return result;
        }
      }

      // 查找slot中的组件
      if (component.$slots) {
        for (const slotName in component.$slots) {
          const slot = component.$slots[slotName];
          for (const vnode of slot) {
            if (vnode.componentInstance) {
              const result = this.findRefByName(refName, vnode.componentInstance);
              if (result) {
                return result;
              }
            }
          }
        }
      }

      return null;
    },
    onTabChange(index, initAnchorRefName) {
      this.activeTab = index;

      this.isTabClicking = true;
      if (this.tabClickTimeout) clearTimeout(this.tabClickTimeout);
      // 增加防抖超时时间以作兜底
      this.tabClickTimeout = setTimeout(() => {
        this.isTabClicking = false;
      }, 800);

      if (this.$refs[`tab${index}-ref`] && this.$refs["scroll-container"]) {
        let section;

        // 优先查找指定的ref
        if (initAnchorRefName) {
          const refElement = this.findRefByName(initAnchorRefName, this);
          if (refElement) {
            // 如果找到ref元素，使用它
            section = Array.isArray(refElement) ? refElement[0] : refElement;
          }
        }

        // 如果没有找到指定的ref，使用标签页的顶部
        if (!section) {
          section = this.$refs[`tab${index}-ref`][0];
        }

        if (section) {
          const container = this.$refs["scroll-container"];
          const el = section.$el || section;

          if (el && el.getBoundingClientRect) {
            const containerRect = container.getBoundingClientRect();
            const sectionRect = el.getBoundingClientRect();

            // 使用 getBoundingClientRect 计算精准距离。减去 4px 让排版略留边距。
            const targetTop = container.scrollTop + sectionRect.top - containerRect.top - 4;

            if (typeof container.scrollTo === "function") {
              container.scrollTo({
                top: targetTop,
                behavior: "smooth",
              });
            } else {
              container.scrollTop = targetTop;
            }
          }
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.popup-content {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f5f5f5;
  border-radius: 24px 24px 0 0;
  overflow: hidden;
  height: 100vh;
  position: relative;
}

.popup-head {
  height: 56px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 18.49%);
  border-radius: 24px 24px 0 0;
  position: relative;
  z-index: 10;
}

.popup-tabs {
  display: flex;
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
}

.popup-tab-item {
  font-weight: 400;
  font-size: 17px;
  line-height: 1;
  color: #999999;
  margin-right: 18px;
  position: relative;
  cursor: pointer;

  &-active {
    font-weight: 500;
    color: #262626;
  }
}

.popup-body {
  flex: 1;
  overflow: auto;
  padding: 0 12px 50px;
  -webkit-overflow-scrolling: touch; /* 仅移动端必要 */

  &::-webkit-scrollbar {
    display: none;
  }
}

.popup-section {
  padding: 14px 12px;
  box-shadow: 0px 2px 5px 0px #d8def40d;
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 12px;
  &::last-child {
    margin-bottom: 0;
  }
  &-title {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 15px;
    line-height: 1;
    color: #262626;
    margin-bottom: 14px;
  }
}

.popup-fade-enter-active,
.popup-fade-leave-active {
  transition: opacity 0.3s ease;
}

.popup-fade-enter,
.popup-fade-leave-to {
  opacity: 0;
}

.popup-slide-enter-active {
  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.popup-slide-leave-active {
  transition: transform 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.popup-slide-enter,
.popup-slide-leave-to {
  transform: translateY(100%);
}
</style>



// WEBPACK FOOTER //
// ServiceTipTagWeb.vue?f6fb6e90